<template>
    <div class="title-segment" :class="[ segmentData.style ? `${segmentData.style}-style` : null ]">
        <h3>{{ segmentData.title }}</h3>
    </div>
</template>

<script>
    export default {
        props: {
            id: String,
            segmentData: Object,
            displayOnly: Boolean,
        },
    }
</script>

<style lang="scss">
    
</style>